import { AnimatePresence }  from 'motion/react'
import { apply }            from 'ramda'
import { Icon }             from 'semantic-ui-react'
import { Label }            from 'semantic-ui-react'
import { motion }           from 'motion/react'
import { useRef }           from 'react'
import { useTextField }     from 'react-aria'
import { without }          from 'ramda'
import Stick                from 'react-stick'

import unwords from '../string/unwords.js'

export default TextField

/**
 * Properties -> React.ReactNode
 * Properties = {
 *  autoFocus       : Undefined | Boolean
 *  defaultValue    : Undefined | String
 *  disabled        : Undefined | Boolean
 *  icon            : Undefined | String
 *  iconPosition    : Undefined | 'left' | 'right'
 *  label           : Undefined | String
 *  loading         : Undefined | Boolean
 *  onChange        : Undefined | ((React.ChangeEvent HTMLInputElement) -> *)
 *  readOnly        : Undefined | Boolean
 *  required        : Undefined | Boolean
 *  type            : Undefined | String
 *  value           : Undefined | String
 * }
 * @param properties Properties
 * @return React.ReactNode
 */
function TextField (properties) {

    const { icon }          = properties
    const { iconPosition }  = properties
    const { label }         = properties
    const { loading }       = properties

    const reference = useRef (null)

    const state = apply (useTextField) ([
        {

            ... properties,

            isDisabled:         properties.disabled,
            isReadOnly:         properties.readOnly,
            isRequired:         properties.required,
            validationBehavior: 'native'

        },
        reference
    ])

    const { disabled }  = state.inputProps
    const { isInvalid } = state
    const { required }  = state.inputProps

    const formControlProperties = {

        autoFlipVertically: true,
        inline:             true,
        position:           'bottom center',

        className: unwords (without ([false]) ([
            disabled && 'disabled',
            'field',
            required && 'required',
            isInvalid && 'error'
        ])),

        node: (<AnimatePresence>
            { isInvalid && <Label { ... {

                ... state.errorMessageProps,

                as:         motion.label,
                children:   unwords (state.validationErrors),
                pointing:   'above',
                prompt:     true,

                animate: {
                    opacity: 1
                },

                exit: {
                    opacity: 0,
                },

                initial: {
                    opacity: 0
                },

                transition: {
                    duration:   .2,
                    ease:       [.34, .8, .34, 1]
                }

            } } /> }
        </AnimatePresence>)
    }

    const inputContainerClass = unwords (without ([false]) ([
        (icon || loading) && unwords (without ([undefined]) ([
            iconPosition,
            'icon'
        ])),
        disabled && 'disabled',
        'input',
        isInvalid && 'error',
        loading && 'loading',
        'ui'
    ]))

    return <Stick { ... formControlProperties }>

        { label != null && <label { ... state.labelProps }>
            { label }
        </label> }

        <div className={ inputContainerClass }>

            <input { ... state.inputProps } ref={ reference } />

            { loading
            ? <Icon name="spinner" />
            : icon && <Icon name={ icon } /> }

        </div>

    </Stick>

}
